<app-dashboard *ngIf="isDisplayDashboard == true"></app-dashboard>
<!-- <router-outlet></router-outlet> -->
<ng-container *ngIf="!isDisplayDashboard">
<div [ngSwitch]="path" >
<app-forgotpwd *ngSwitchCase="'forgotpassword'" ></app-forgotpwd>
<app-resetpwd *ngSwitchCase="'resetpwd'" ></app-resetpwd>
<app-registerotp *ngSwitchCase="'registerotp'" ></app-registerotp>
<app-login  *ngSwitchDefault ></app-login>
</div>
</ng-container>